export default __webpack_public_path__ + "cf8ea6ecd26fc3fe406cabe874460435.svg";